/** 租户退款 /metering/finance/new-tenant-refund */
export default {
  tenantRefundPage: {
    phDateStart: '开始日期',
    phDateEnd: '结束日期',
    phTenant: '租户名称/编号',
    phAuditStatus: '审核状态',
    btnSearch: '查询',
    btnReset: '重置',
    btnExport: '导出',
    sectionTitle: '租户退款',
    sortDefault: '默认排序',
    colRid: '流水号',
    colApplyTime: '申请时间',
    colTenantName: '租户名',
    colBizType: '账户类型',
    colRefundType: '退款类型',
    colApplyAmt: '申请退款金额（元）',
    colActualAmt: '实际退款金额（元）',
    colAuditStatus: '审核状态',
    colAction: '操作',
    btnDetail: '详情',
    btnAudit: '审核',
    statusVal0: '管理方审核中',
    statusVal1: '平台已拒绝',
    statusVal2: '平台审核中',
    statusVal3: '已退款',
    statusVal4: '退款中',
    statusVal5: '管理方已拒绝',
    statusVal6: '租户撤销',
    refundTypeCorporate: '对公充值',
    bizElectric: '电费专户',
    bizWater: '水费专户',
    shortcutYesterday: '昨天',
    shortcutThisWeek: '本周',
    shortcutLastWeek: '上周',
    shortcutThisMonth: '本月',
    shortcutLastMonth: '上月',
    shortcutLast3Months: '近三个月',
    shortcutLastYear: '近一年',
    msgTenantListFail: '获取租户列表失败',
    msgRefundListFail: '获取退款数据失败',
    msgNoDataExport: '暂无数据可导出',
    msgExportFail: '导出失败',
    msgExportOk: '已导出 {count} 条',
    exportSheetName: '租户退款',
    filePrefix: '租户退款',
    exportCurrentPage: '导出本页',
    exportSelected: '导出选中',
    exportAll: '导出全部',
    warnNoSelectedExport: '请先选择要导出的数据',
    msgExportOkSelected: '已导出选中 {count} 条',
    successExported: '已导出 {count} 条',
    successExportedLimit: '数据量超过 {total} 条，已导出前 {count} 条',
    exporting: '导出中...',
    msgNoAuditPerm: '暂无审核权限',
    msgNoViewPerm: '暂无查看权限',
    msgDetailDisabled: '管理方审核中状态，详情不可查看',
    msgDetailFail: '获取详情失败',
    msgTenantAccountFail: '获取租户账户详情失败',
    detailTitle: '退款详情',
    detailSeqInline: '流水号：',
    detailLblRid: '退款流水号',
    detailLblTenantId: '租户ID',
    detailLblTenantName: '租户名称',
    detailLblManagerName: '项目名称',
    detailLblBizType: '账户类型',
    detailLblPayeeName: '收款账户名称',
    detailLblBankNumber: '收款账号',
    detailLblOpeningBank: '开户行',
    detailLblProjectReviewer: '项目审核人',
    detailLblApplyTime: '申请时间',
    detailLblProcessTime: '审核时间',
    detailLblRefundTime: '退款时间',
    detailLblRealCash: '专户现金余额(元)',
    detailLblApplyAmt: '申请退款金额(元)',
    detailLblActualAmt: '实际退款金额(元)',
    detailLblAuditStatus: '审核状态',
    detailLblRefuseMsg: '拒绝原因',
    btnClose: '关闭',
    auditTitle: '退款审核',
    auditLblApplyAmt: '申请退款金额(元)',
    auditLblRefundable: '租户可退余额(元)',
    auditLblBankAccount: '银行账户',
    auditLblOpeningBank: '开户银行',
    auditLblAccountName: '开户名称',
    auditLblOpinion: '审核意见',
    auditAgree: '同意',
    auditReject: '拒绝',
    auditLblRefundAmt: '退款金额',
    phRefundAmt: '请输入退款金额',
    auditLblRefuseReason: '拒绝原因',
    phRefuseReason: '请输入拒绝原因',
    smsTitle: '短信验证',
    smsLblPhone: '绑定手机',
    smsLblCode: '验证码',
    phSmsCode: '请输入验证码',
    btnSendCode: '发送验证码',
    btnCancel: '取消',
    btnConfirm: '确认',
    confirmTitle: '提示',
    confirmOk: '确定',
    confirmCancel: '取消',
    confirmAuditPass: '是否通过退款申请？',
    confirmAuditReject: '是否拒绝退款申请？',
    ruleSelectOpinion: '请选择审核意见',
    ruleRefundAmt: '请输入退款金额',
    ruleRefuseReason: '请输入拒绝原因',
    msgFillAudit: '请填写完整的审核信息',
    msgEnterRefundAmt: '请输入退款金额',
    msgRefundAmtTooHigh: '退款金额不能大于申请金额',
    msgEnterSmsCode: '请输入验证码',
    msgSmsSent: '验证码已发送',
    msgSmsSendFail: '发送验证码失败',
    msgOpSuccess: '操作成功',
    msgOpFail: '操作失败',
    msgAuditFail: '退款审核失败'
  }
}
